import { useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

// Pre-typed versions of the react-redux hooks — use these throughout the app
// instead of the plain `useDispatch` / `useSelector`.
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
